var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#173CBA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.3,272v-47.7c0-12.2-9.9-22.2-22.2-22.2H255c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7h181.2 c8.2,0,14.8,6.6,14.8,14.8V272c-3.3,1.4-5.5,4.7-5.5,8.5c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2 C463.9,276.7,461.6,273.5,458.3,272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.1,286.5c0,0-4.5,4.6-5.7,14.3c-3.1,25.7-0.4,50.2-0.4,50.2s6.1,3.2,18.7,0.8c0.2,0,0.6-0.1,0.6-0.1 s-1.3-3.3-2.1-6.8c-0.9-4.3-0.7-9.1-0.7-9.1s2.6,4.9,5.3,8.6c2.8,3.9,5,5.2,5.5,5c7.1-2.7,10.1-6,10.1-6s-7.5-6.6-13.9-30.8 c-2.8-10.6-3-19-3.7-22.2c-0.7-3.2-1.9-5.1-1.9-5.1L449.1,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,102.2L19,205.9v12.8l236,103.7l184.9-81.2v-16.8c0-2-1.7-3.7-3.7-3.7H255c-8.2,0-14.8-6.6-14.8-14.8 c0-8.2,6.6-14.8,14.8-14.8h181.2c18.3,0,33.3,14.9,33.3,33.3v3.8l21.6-9.5v-12.8L255,102.2z M248.1,291c1.6,0.7,4.8,0.7,6.4,0 l139.1-61.1c2.3-1,5.1,0,6.1,2.4c1,2.3,0,5.1-2.4,6.1l-139.1,61.1c-2,0.9-4.5,1.3-6.9,1.3c-2.5,0-4.9-0.4-6.9-1.3l-192-84.4 c-2.3-1-3.4-3.8-2.4-6.1c1-2.3,3.7-3.4,6.1-2.4L248.1,291z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.2,277.9l-137.4,60.4c-3.7,1.6-9.8,1.6-13.5,0l-137.4-60.4c-3.7-1.6-6.8,0.3-6.8,4.4v81.3 c0,25.5,67.6,46.2,151,46.2c83.4,0,151-20.7,151-46.2v-81.3C406,278.2,402.9,276.2,399.2,277.9z M394.6,362.4 c0,2.6-2.1,4.6-4.6,4.6c-2.6,0-4.6-2.1-4.6-4.6v-56.7c0-2.6,2.1-4.6,4.6-4.6c2.6,0,4.6,2.1,4.6,4.6V362.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduateIcon);
export default __webpack_public_path__ + "static/media/graduate-icon.be5a620b294d2609313809b61abaa2d3.svg";
export { ForwardRef as ReactComponent };